import React from 'react';
import { motion } from 'framer-motion';

const GameGridSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[...Array(6)].map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 }}
          className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 border border-gray-700/50"
        >
          <div className="animate-pulse">
            <div className="flex justify-between items-center mb-3">
              <div className="h-4 w-20 bg-gray-700 rounded"></div>
              <div className="h-3 w-16 bg-gray-700 rounded"></div>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-700 rounded-full"></div>
                <div className="flex-1">
                  <div className="h-4 w-24 bg-gray-700 rounded mb-1"></div>
                  <div className="h-3 w-16 bg-gray-700 rounded"></div>
                </div>
                <div className="h-8 w-8 bg-gray-700 rounded"></div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-700 rounded-full"></div>
                <div className="flex-1">
                  <div className="h-4 w-24 bg-gray-700 rounded mb-1"></div>
                  <div className="h-3 w-16 bg-gray-700 rounded"></div>
                </div>
                <div className="h-8 w-8 bg-gray-700 rounded"></div>
              </div>
            </div>
            
            <div className="mt-3 h-8 bg-gray-700 rounded"></div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

const StandingsTableSkeleton = () => {
  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700/50">
      <div className="animate-pulse">
        <div className="h-6 w-32 bg-gray-700 rounded mb-4"></div>
        
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700/50">
                {[...Array(13)].map((_, index) => (
                  <th key={index} className="py-3 px-2">
                    <div className="h-4 w-8 bg-gray-700 rounded mx-auto"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(8)].map((_, rowIndex) => (
                <tr key={rowIndex} className="border-b border-gray-700/30">
                  <td className="py-3 px-2">
                    <div className="w-8 h-8 bg-gray-700 rounded-full"></div>
                  </td>
                  <td className="py-3 px-2">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-gray-700 rounded-full"></div>
                      <div className="h-4 w-20 bg-gray-700 rounded"></div>
                    </div>
                  </td>
                  {[...Array(11)].map((_, cellIndex) => (
                    <td key={cellIndex} className="py-3 px-2 text-center">
                      <div className="h-4 w-8 bg-gray-700 rounded mx-auto"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const PlayerGridSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {[...Array(8)].map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.05 }}
          className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 border border-gray-700/50"
        >
          <div className="animate-pulse">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-16 h-16 bg-gray-700 rounded-full"></div>
              <div className="flex-1">
                <div className="h-5 w-24 bg-gray-700 rounded mb-2"></div>
                <div className="h-4 w-20 bg-gray-700 rounded"></div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-2">
              {[...Array(4)].map((_, statIndex) => (
                <div key={statIndex} className="bg-gray-900/50 rounded-lg p-2">
                  <div className="flex justify-between items-center">
                    <div className="h-3 w-8 bg-gray-700 rounded"></div>
                    <div className="h-4 w-12 bg-gray-700 rounded"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

const LoadingStates = {
  GameGrid: GameGridSkeleton,
  StandingsTable: StandingsTableSkeleton,
  PlayerGrid: PlayerGridSkeleton,
};

export default LoadingStates;